import { combineReducers } from 'redux'

import deleteNode from './product/delete'
import get from './product/get'
import post from './product/post'
import put from './product/put'

export default combineReducers({
  delete: deleteNode,
  get,
  post,
  put
})



// WEBPACK FOOTER //
// ./src/reducers/root/entities/controls/product.js